import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs';
import {
  CustomerClubDeviceDetailRequest,
  SendTypes,
} from 'src/app/core/api/models';

import { EventTypes } from 'src/app/core/constants/event-types';
import { RegularExpressions } from 'src/app/core/constants/regular-expressions';
import { BaseFormModule } from 'src/app/pages/shared/base';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { PeriodicTypeConfig } from 'src/app/shared/components/periodic-type/periodic-type.component';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';

@Component({
    selector: 'app-customer-club-devices-detail',
    templateUrl: './customer-club-devices-detail.component.html',
    styleUrls: ['./customer-club-devices-detail.component.scss'],
    imports: [BaseFormModule, SmsBodyModule]
})
export class CustomerClubDevicesDetailComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  formId: string = 'textParserIfConditionForm';

  periodicTypeConfig: PeriodicTypeConfig;
  get SendTypes() {
    return SendTypes;
  }

  @Input() detail: CustomerClubDeviceDetailRequest;
  @Input('organizationId') input_organizationId;
  @Input('userId') input_userId;

  @Output('form') output_form = new EventEmitter<FormGroup>();

  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
      this.detectChangeForm();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  initModel() {
    this.periodicTypeConfig = {
      periodTypeLabel: this.fields + 'delayType',
      periodTextLabel: this.fields + 'delayValue',
      periodTypeControl: this.form?.get('sendDelay.delayType') as FormControl,
      periodTextControl: this.form?.get('sendDelay.delayValue') as FormControl,
      periodText: this.detail.delayValue,
      periodType: this.detail.delayType,
    };
  }

  initForm() {
    this.form = new FormGroup({
      privateNumberId: new FormControl('', Validators.required),
      smsBody: new FormControl('', [
        Validators.required,
        // Validators.pattern(RegularExpressions.smsBodyForbiddenCharacters),
      ]),
      isActive: new FormControl(''),
      dynamicTemplateId: new FormControl(''),
      sendDelay: new FormGroup({
        delayValue: new FormControl(''),
        delayType: new FormControl(''),
      }),
    });
  }

  detectChangeForm() {
    try {
      this.form.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((event) => {
          this.emitForm();
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  emitForm() {
    this.output_form.emit(this.form);
  }
}
